<template>
  <div class="container-fluid customer-profile-container">
    <b-card
      class="
        card-transparent-background card-customer-profile-container-dy
        mt-md-5 mt-1
      "
    >
      <!-- card profile picture -->
      <b-row class="mt-md-5 mt-1">
        <b-col lg="10" md="11" class="mx-auto">
          <b-card class="card-dark-transparent-background-dy">
            <b-row class="row-profile-no-border-dy p-0" align-v="center"
              ><b-col lg="9" md="10" class="pl-0 text-center">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="5"
                  label-cols-md="4"
                  label-cols-lg="3"
                  content-cols="7"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="Profile picture"
                >
                  <div
                    class="profile-pic-edit-container-dy"
                    :class="{ active: is_edit_profile_picture == true }"
                  >
                    <div class="profile-pic-edit-action-dy text-center">
                      <div
                        class="
                          profile-edit-img-text-dy profile-edit-img-div-dy
                          text-center
                        "
                        :style="{
                          'background-image': 'url(' + profile_pictue_src + ')',
                        }"
                      >
                        <div>
                          <p @click="clickChangePhoto('profile_pic')">
                            Choose photo
                          </p>
                        </div>
                      </div>
                      <input
                        type="file"
                        class="file-upload inputFileHidden d-none"
                        name="profile_pic"
                        id="profile_pic"
                        accept="image/*"
                        @change="previewImage"
                      />
                    </div>
                    <div class="profile-pic-edit-view-dy">
                      <b-avatar
                        v-if="
                          profile_pictue_src != null && profile_pictue_src != ''
                        "
                        variant="light"
                        size="80px"
                        class="profile-edit-img-text-dy"
                        :src="profile_pictue_src"
                      ></b-avatar>
                      <b-avatar
                        v-else
                        variant="light"
                        size="80px"
                        class="profile-edit-img-text-dy"
                        :text="avatar_text"
                      ></b-avatar>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_profile_picture"
                    variant="edit-input-dy"
                    @click="clickEdit('profile_picture')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_profile_picture"
                    variant="edit-input-dy"
                    @click="clickChange('profile_picture')"
                  >
                    Upload
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- card account info -->
      <b-row>
        <b-col lg="10" md="11" class="mx-auto">
          <b-card class="card-dark-transparent-background-dy">
            <!-- first name -->
            <b-row class="row-profile-border-dy mb-2"
              ><b-col lg="9" md="10" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  :content-cols="is_edit_first_name == true ? '12' : '8'"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="First name"
                >
                  <b-form-input
                    v-if="is_edit_first_name"
                    class="form-control-profile form-control-profile-doom-yoga"
                    id="first_name"
                    v-model="first_name"
                    type="text"
                    required
                  ></b-form-input>
                  <span
                    v-if="!is_edit_first_name"
                    class="profile-data-value-doom-yoga"
                  >
                    {{ first_name }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_first_name"
                    variant="edit-input-dy"
                    @click="clickEdit('first_name')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_first_name"
                    variant="edit-input-dy"
                    @click="clickChange('first_name')"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- end first name -->
            <!-- last name -->
            <b-row class="row-profile-border-dy mb-2"
              ><b-col lg="9" md="10" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  :content-cols="is_edit_last_name == true ? '12' : '8'"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="Last name"
                >
                  <b-form-input
                    v-if="is_edit_last_name"
                    class="form-control-profile form-control-profile-doom-yoga"
                    id="last_name"
                    v-model="last_name"
                    type="text"
                    required
                  ></b-form-input>
                  <span
                    v-if="!is_edit_last_name"
                    class="profile-data-value-doom-yoga"
                  >
                    {{ last_name }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_last_name"
                    variant="edit-input-dy"
                    @click="clickEdit('last_name')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_last_name"
                    variant="edit-input-dy"
                    @click="clickChange('last_name')"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- end last name -->
            <!-- email -->
            <b-row class="row-profile-border-dy mb-2"
              ><b-col lg="9" md="10" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  :content-cols="is_edit_email == true ? '12' : '8'"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="Email"
                >
                  <b-form-input
                    v-if="is_edit_email"
                    class="form-control-profile form-control-profile-doom-yoga"
                    id="email"
                    v-model="email"
                    type="text"
                    required
                  ></b-form-input>
                  <span v-else class="profile-data-value-doom-yoga">
                    {{ email }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_email"
                    variant="edit-input-dy"
                    @click="clickEdit('email')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_email"
                    variant="edit-input-dy"
                    @click="clickChange('email')"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- end email -->
            <!-- phone number -->
            <b-row class="row-profile-border-dy mb-2"
              ><b-col lg="9" md="10" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  :content-cols="is_edit_phone == true ? '12' : '8'"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="Phone"
                >
                  <vue-tel-input
                    v-if="is_edit_phone"
                    class="
                      form-control
                      form-control-profile
                      form-control-profile-doom-yoga
                    "
                    id="phone_number"
                    v-model="phone_number"
                    required
                  ></vue-tel-input>
                  <span v-else class="profile-data-value-doom-yoga">
                    {{ phone_number }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_phone"
                    variant="edit-input-dy"
                    @click="clickEdit('phone')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_phone"
                    variant="edit-input-dy"
                    @click="clickChange('phone')"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- end phone -->
            <!-- password -->
            <b-row class="row-profile-no-border-dy mb-2" align-v="center"
              ><b-col lg="10" md="10" class="pl-0">
                <b-form-group
                  v-if="!is_edit_password"
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  content-cols="8"
                  content-cols-md="8"
                  content-cols-lg="9"
                  label-align="left"
                  label="Password"
                >
                  <span class="profile-data-value-doom-yoga"> </span>
                </b-form-group>
                <div v-else>
                  <b-form-group
                    class="form-group-edit-profile-dy"
                    label-cols="4"
                    label-cols-md="4"
                    label-cols-lg="3"
                    :content-cols="is_edit_password == true ? '12' : '8'"
                    content-cols-md="8"
                    content-cols-lg="9"
                    label-align="left"
                    label="Password"
                    label-class="align-baseline"
                  >
                    <b-form-group
                      class="form-group-sub-edit-profile-dy"
                      label-cols="6"
                      content-cols="6"
                      label-align="left"
                      label="Current password"
                    >
                      <b-form-input
                        class="
                          form-control-profile form-control-profile-doom-yoga
                        "
                        id="password"
                        v-model="password"
                        type="password"
                        required
                      ></b-form-input> </b-form-group
                    ><b-form-group
                      class="form-group-sub-edit-profile-dy"
                      label-cols="6"
                      content-cols="6"
                      label-align="left"
                      label="New password"
                    >
                      <b-form-input
                        class="
                          form-control-profile form-control-profile-doom-yoga
                        "
                        id="new_password"
                        v-model="new_password"
                        type="password"
                        required
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="form-group-sub-edit-profile-dy"
                      label-cols="6"
                      content-cols="6"
                      label-align="left"
                      label="Confirm new password"
                    >
                      <b-form-input
                        class="
                          form-control-profile form-control-profile-doom-yoga
                        "
                        id="confirm_new_password"
                        v-model="confirm_new_password"
                        type="password"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-form-group>
                </div>
              </b-col>
              <b-col lg="2" md="2" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_password"
                    variant="edit-input-dy"
                    @click="clickEdit('password')"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_password"
                    variant="edit-input-dy"
                    @click="clickChange('password')"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <!-- end password -->
          </b-card>
        </b-col>
      </b-row>
      <!-- card subscription-->
      <b-row>
        <b-col lg="10" md="11" class="mx-auto">
          <b-card class="card-dark-transparent-background-dy">
            <b-row class="row-profile-no-border-dy my-2"
              ><b-col lg="9" md="10" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="4"
                  label-cols-md="4"
                  label-cols-lg="3"
                  content-cols="8"
                  content-cols-md="8"
                  content-cols-lg="7"
                  label-align="left"
                  label="Subscription"
                >
                  <span class="profile-data-value-doom-yoga">
                    {{ subscription }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col lg="2" md="2" offset-lg="1" class="pr-0">
                <div class="float-right">
                  <!-- <b-button variant="edit-input-dy"> Manage </b-button>  -->
                  <router-link
                    to="/doom_yoga/my_profile/subscription"
                    class="btn btn-edit-input-dy"
                    >Manage</router-link
                  >
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import $ from "jquery";

export default {
  name: "DoOmYogaCustomerEditProfile",
  components: {},
  data() {
    return {
      profile_pictue_src:
        "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
      // profile_pictue_src_preview:
      //   "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
      profile_pictue_src_new: null,
      is_edit_profile_picture: false,
      first_name: "",
      is_edit_first_name: false,
      last_name: "",
      is_edit_last_name: false,
      email: "",
      is_edit_email: false,
      phone_number: "",
      is_edit_phone: false,
      password: "",
      new_password: "",
      confirm_new_password: "",
      is_edit_password: false,
      subscription: "Monthly Plan - 99€",
      avatar_text:null
    };
  },
   mounted() {
    console.log(window.localStorage.getItem("user"));
    this.login_user = JSON.parse(window.localStorage.getItem("user"));
    this.first_name = this.login_user.first_name;
    this.last_name = this.login_user.second_name;
    this.email = this.login_user.email;
    this.phone_number = this.login_user.phone;
    this.avatar_text = this.first_name[0]+this.last_name[0]
    this.profile_pictue_src = this.login_user.mainImage
  },
  methods: {
    clickChangePhoto(id) {
      console.log("click change photo");
      $("#" + id).click();
    },
    previewImage: function (e) {
      var input = e.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          this.profile_pictue_src = e.target.result;
        };
        this.profile_pictue_src_new = e.target.files[0];
        console.log(this.profile_pictue_src_new);
      }
    },
    clickEdit(input) {
      console.log("click edit ", input);
      if (input == "first_name") {
        this.is_edit_first_name = true;
      }
      if (input == "last_name") {
        this.is_edit_last_name = true;
      }
      if (input == "email") {
        this.is_edit_email = true;
      }
      if (input == "phone") {
        this.is_edit_phone = true;
      }
      if (input == "password") {
        this.is_edit_password = true;
      }
      if (input == "profile_picture") {
        this.is_edit_profile_picture = true;
      }
    },
    clickChange(input) {
      console.log("click change ", input);
      if (input == "first_name") {
        this.is_edit_first_name = false;
        console.log("first name ", this.first_name);
      }
      if (input == "last_name") {
        this.is_edit_last_name = false;
        console.log("last name ", this.last_name);
      }
      if (input == "email") {
        this.is_edit_email = false;
        console.log("email ", this.email);
      }
      if (input == "phone") {
        this.is_edit_phone = false;
        console.log("phone ", this.phone_number);
      }
      if (input == "password") {
        this.is_edit_password = false;
        console.log(
          "password ",
          this.password,
          this.new_password,
          this.confirm_new_password
        );
      }
      if (input == "profile_picture") {
        this.is_edit_profile_picture = false;
        console.log("upload profile picture ");
        console.log(this.profile_pictue_src_new);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Profile/EditProfile.vue